import {
  Actor,
  Animation,
  CollisionType,
  Keys,
  SpriteSheet,
  vec,
  Vector,
} from "excalibur";
import { Resources } from "../../Resources";
import { Config } from "../../config";
import Dialog from "../../ui/dialog";
import QuestionDialog from "../../ui/questionDialog";
import getNPCContent from "../../content/npcContent";
import { inventoryState, playerState } from "../../state/stateManager";
import { goToScene } from "../../main";
import { createGainedItem } from "../../utils";

export default class Bill extends Actor {
  constructor(pos, scene) {
    super({
      x: pos.x,
      y: pos.y,
      width: 32,
      height: 32,
      radius: 20,
      name: "bill",
    });
    this.collider = new Actor({
      pos: new Vector(0, 0),
      width: 16,
      height: 16,
      collisionType: CollisionType.Fixed,
      name: "bill",
    });

    console.log("inside bill constructor: scene is: ", scene);
    this.sceneRef = scene;
    this.started = false;
    this.interacting = false;
    this.interactionTime = null;
    this.cutScene = false;
    this.z = 5;
  }

  onInitialize() {
    const playerSpriteSheet = SpriteSheet.fromImageSource({
      image: Resources.FarleySpriteSheet,
      grid: {
        spriteWidth: 32,
        spriteHeight: 32,
        rows: 5,
        columns: 4,
      },
    });

    const leftIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const rightIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(3, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const upIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(1, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const downIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(1, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const sitAtBooth = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(1, 4),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const downWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const upWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const leftWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const rightWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("leftIdle", leftIdle);
    this.graphics.add("rightIdle", rightIdle);
    this.graphics.add("upIdle", upIdle);
    this.graphics.add("downIdle", downIdle);
    this.graphics.add("leftWalk", leftWalk);
    this.graphics.add("rightWalk", rightWalk);
    this.graphics.add("upWalk", upWalk);
    this.graphics.add("downWalk", downWalk);
    this.graphics.add("sitAtBooth", sitAtBooth);
    this.addChild(this.collider);

    const shadowSprite = playerSpriteSheet.getSprite(0, 4);
    const shadow = new Actor({ pos: new Vector(0, 3), z: 2 });
    shadow.graphics.add("shadow", shadowSprite);

    shadow.graphics.use("shadow");

    this.addChild(shadow);
  }
  moveFunction(direction, amount) {
    console.log("cutscene: inside marvin move");
    switch (direction) {
      case "left":
        this.graphics.use("leftWalk");
        this.vel = vec(-Config.GrandpaSpeed, 0);

        this.lastDir = "left";
        break;
      case "right":
        this.graphics.use("rightWalk");
        this.vel = vec(Config.GrandpaSpeed, 0);

        this.lastDir = "right";
        break;
      case "up":
        this.graphics.use("upWalk");
        this.vel = vec(0, -Config.GrandpaSpeed);

        this.lastDir = "up";
        break;
      case "down":
        this.graphics.use("downWalk");
        this.vel = vec(0, Config.GrandpaSpeed);

        this.lastDir = "down";
        break;
      default:
        break;
    }
  }
  startTownAuto() {
    console.log("inside startAuto");
    this.actions.repeatForever((ctx) => {
      this.started = true;
      ctx
        .callMethod(() => {
          this.graphics.use("downWalk");
        })
        .moveTo(5 * 16, 54 * 16, 10)
        .callMethod(() => {
          this.graphics.use("downIdle");
        })
        .delay(1000)
        .callMethod(() => {
          this.graphics.use("rightWalk");
        })
        .moveTo(29 * 16, 54 * 16, 10)
        .callMethod(() => {
          this.graphics.use("rightIdle");
        })
        .delay(1000)

        .callMethod(() => {
          this.graphics.use("upWalk");
        })
        .moveTo(29 * 16, 29 * 16, 10)
        .callMethod(() => {
          this.graphics.use("upIdle");
        })
        .delay(1000)

        .callMethod(() => {
          this.graphics.use("leftWalk");
        })
        .moveTo(16 * 16, 29 * 16, 10)
        .callMethod(() => {
          this.graphics.use("leftIdle");
        })
        .delay(1000)
        .callMethod(() => {
          this.graphics.use("rightWalk");
        })
        .moveTo(29 * 16, 29 * 16, 10)
        .callMethod(() => {
          this.graphics.use("rightIdle");
        })
        .delay(1000)
        .callMethod(() => {
          this.graphics.use("downWalk");
        })
        .moveTo(29 * 16, 54 * 16, 10)
        .callMethod(() => {
          this.graphics.use("downIdle");
        })
        .callMethod(() => {
          this.graphics.use("leftWalk");
        })
        .moveTo(5 * 16, 54 * 16, 10)
        .callMethod(() => {
          this.graphics.use("upWalk");
        })
        .moveTo(5 * 16, 51 * 16, 10);
    });
  }

  startInteraction(lastDir, player) {
    let now = new Date().getTime();
    this.player = player;
    if (this.interactionTime == null || now - this.interactionTime > 5000) {
      this.interacting = true;
      this.actions.clearActions();
      player.cutScene = true;
      console.log("inside startInteraction, ", lastDir);
      switch (lastDir) {
        case "left":
          this.graphics.use("rightIdle");
          break;
        case "right":
          this.graphics.use("leftIdle");
          break;
        case "up":
          this.graphics.use("downIdle");
          break;
        case "down":
          this.graphics.use("upIdle");
          break;
        default:
          break;
      }

      this.displayProperQuestion();
    } else {
      return;
    }
  }

  showDialog() {
    console.log("showing dialog: question is: ", this.activeQuestion);
    this.greetingDialog = new QuestionDialog(
      [this.activeQuestion.question],
      this.activeQuestion.replies,
      (reply, replyIndex) => {
        console.log("dialog ended");
        if (this.activeQuestion.replies.length !== 0) {
          this.setRepliesToState(this.activeQuestion.relationship[replyIndex]);
        } else {
          this.setRepliesToState({ shouldShow: null });
        }
      },
      "bill",
      "top"
    );
  }
  displayProperQuestion() {
    this.questions = getNPCContent();
    this.content = playerState.getContent();
    if (!this.content.bill.met) {
      console.log("havent met, showing first question");
      this.activeQuestion = this.questions.bill.questions.firstQuestion;
      this.showDialog();
    } else {
      console.log(
        "have met, showing random,relationship is: ",
        this.content.bill.relationship
      );
      //random question based on relationship
      if (this.content.bill.relationship < 0) {
        let qu =
          this.questions.bill.randomQuestions.reallyLow[
            Math.floor(
              Math.random() *
                this.questions.bill.randomQuestions.reallyLow.length
            )
          ];
        this.activeQuestion = qu;
      } else if (
        this.content.bill.relationship < 10 &&
        this.content.bill.relationship >= 0
      ) {
        //low level question
        console.log("have met, relationship low");
        let qu =
          this.questions.bill.randomQuestions.lowLevel[
            Math.floor(
              Math.random() *
                this.questions.bill.randomQuestions.lowLevel.length
            )
          ];
        this.activeQuestion = qu;
      } else if (10 <= this.content.bill.relationship <= 20) {
        //mid level question
        let qu =
          this.questions.bill.randomQuestions.midLevel[
            Math.floor(
              Math.random() *
                this.questions.bill.randomQuestions.midLevel.length
            )
          ];
        this.activeQuestion = qu;
      } else if (this.content.bill.relationship > 20) {
        //high level question
        let qu =
          this.questions.bill.randomQuestions.highLevel[
            Math.floor(
              Math.random() *
                this.questions.bill.randomQuestions.highLevel.length
            )
          ];
        this.activeQuestion = qu;
      }
      this.showDialog();
    }
  }

  setRepliesToState(relationshipImpact) {
    console.log(
      "inside setRepliesToState: relationshipimpact is: ",
      relationshipImpact
    );

    let content = playerState.getContent();
    if (relationshipImpact.relationshipBump) {
      content.bill.relationship =
        parseInt(content.bill.relationship) +
        parseInt(relationshipImpact.relationshipBump);
    }

    content.bill.met = true;
    this.content = content;
    if (relationshipImpact.shouldShow) {
      //should show followup dialog

      if (relationshipImpact.shouldShow == "sellHoney") {
        let inventory = inventoryState.getInventory();
        if (inventory.filledJars > 0) {
          inventory.filledJars = inventory.filledJars - 1;
          Resources.Inventory.play();
          createGainedItem("You Gifted 1 Honey Jar!");
          createGainedItem("Brand Awareness + 2!");
          this.content.brandAwareness = this.content.brandAwareness + 2;
          this.activeQuestion = this.questions.bill.questions.thanks;
          this.showDialog();
        } else {
          Resources.Error.play();
          sendAlert("Not Enough Supply");
          this.player.cutScene = false;
          this.interacting = false;
          this.interactionTime = new Date().getTime();
        }
      } else {
        console.log(
          "shouldShow is: ",
          this.questions.bill.questions[relationshipImpact.shouldShow]
        );
        this.activeQuestion =
          this.questions.bill.questions[relationshipImpact.shouldShow];
        this.showDialog();
      }
    } else {
      this.player.cutScene = false;
      this.interacting = false;
      this.interactionTime = new Date().getTime();
    }
  }
  startBillsHouseAuto() {
    console.log("inside startAuto");
    this.actions.repeatForever((ctx) => {
      this.started = true;
      ctx
        .callMethod(() => {
          this.graphics.use("rightWalk");
        })
        .moveTo(15 * 16, 6 * 16, 10)
        .callMethod(() => {
          this.graphics.use("downIdle");
        })
        .delay(1000)
        .callMethod(() => {
          this.graphics.use("leftWalk");
        })
        .moveTo(14 * 16, 6 * 16, 10)
        .callMethod(() => {
          this.graphics.use("downIdle");
        })
        .delay(1000);
    });
  }
  onPostUpdate(engine) {
    if (!this.started && !this.cutScene && this.sceneRef == "billsHouse") {
      this.startBillsHouseAuto();
    } else if (
      (!this.started && (!this.cutScene == this.sceneRef) == "farmersMarket") ||
      this.sceneRef == "sparkys"
    ) {
      this.graphics.use("leftIdle");
    }
    if (this.interacting) {
      if (engine.input.keyboard.wasPressed(Keys.Enter)) {
        this.greetingDialog.enterPress();
      }
      if (engine.input.keyboard.wasPressed(Keys.X)) {
        this.interacting = false;
        this.greetingDialog.destroy();
      }
      if (engine.input.keyboard.wasPressed(Keys.Up)) {
        this.greetingDialog.iterateReply(true);
      }
      if (engine.input.keyboard.wasPressed(Keys.Down)) {
        this.greetingDialog.iterateReply(false);
      }
      if (engine.input.keyboard.wasPressed(Keys.X)) {
        this.interacting = false;
        this.player.cutScene = false;
        this.greetingDialog.destroy();
      }
    }
  }
}
